import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export interface CommercialConditionsModalProps extends Pick<ModalProps, 'isOpen' | 'onClose'> {
  onConfirm(): void;
}

export const CommercialConditionsModal = ({ isOpen, onClose, onConfirm }: CommercialConditionsModalProps) => {
  const { t } = useTranslation();

  const handleExport = () => {
    onConfirm?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_title')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction='column' gap={4}>
            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_plan_label')}</Text>
                <Text>Plus</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_start_date_label')}</Text>
                <Text>01/07/2024</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_validity_label')}</Text>
                <Text>12 meses</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_setup_label')}</Text>
                <Text>R$ 8.000</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_monthly_fee_label')}</Text>
                <Text>R$ 5.800,00</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_extra_users_label')}</Text>
                <Text>R$ 1,00 (por cada usuário extra)</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_subscription_commission_label')}</Text>
                <Text>50% (por cada assinatura de usuário)</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_banner_label')}</Text>
                <Text>R$ 1.000,00 (por cada banner)</Text>
              </Flex>
            </Flex>

            <Flex alignItems='center' gap={1}>
              <ChakraFeatherIcon name='check-circle' />

              <Flex direction='column'>
                <Text fontWeight='bold'>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_remarks_label')}</Text>
                <Text>Isenção do setup e da mensalidade pelos primeiros 12 (doze) meses, a contar a partir de novembro/24</Text>
              </Flex>
            </Flex>
          </Flex>
        </ModalBody>

        <ModalFooter gap='kilo'>
          <Button variant='outlined' color='gray.600' onClick={onClose}>
            {t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_close_button')}
          </Button>
          <Button onClick={handleExport}>{t('pages.financial.components.commercial_conditions_modal.financial_commercial_conditions_export_button')}</Button>
        </ModalFooter>
        </ModalContent>
      </Modal>
  );
};